<div class="wrap">
  <h4>Modification du mot de passe</h4>
  <form [formGroup]="updatePasswordProfilForm" (ngSubmit)="onSubmit()" *ngIf="!paswordUpdate">
    <div class="label old">
      <label for="oldPassword">Ancien mot de passe</label>
      <input type="password" name="oldPassword" id="oldPassword" formControlName="oldPassword"
        (input)="isInactive($event.target.value)">
    </div>
    <div class=" label new">
      <label for="newPassword">Nouveau mot de passe </label>
      <input type="password" name="newPassword" id="newPassword" formControlName="newPassword"
        matTooltip="Minimum huit caractères, au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial"
        (input)="isInactive($event.target.value)">
    </div>
    <div class=" label confirm">
      <label for="confirmNewPassword">Confirm. nouveau mot de passe</label>
      <input type="password" name="confirmNewPassword" id="confirmNewPassword" formControlName="confirmNewPassword"
        matTooltip="Minimum huit caractères, au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial"
        (input)="isInactive($event.target.value)">
    </div>
    <div class=" btn_action">
      <span (click)="getShowValue()">Annuler</span>
      <button type="submit" [disabled]="loading" [ngClass]="{inactive: !inactive}">Confirmer</button>
    </div>
  </form>
  <div class="confirm" *ngIf="paswordUpdate">
    <div class="validation_mail">
      <div class="check">
        <span class="icon-line line-tip"></span>
        <span class="icon-line line-long"></span>
        <div class="icon-circle"></div>
        <div class="icon-fix"></div>
      </div>
    </div>
    <h4>Mot de passe modifié</h4>
  </div>
</div>